<template>
    <div class="page">
        <div class="top">
            <div class="out" @touchstart="toIndex"></div>
            <h3>上游追溯信息</h3>
        </div>
        <div class="market-message">
            <div class="pro-market">批发市场: <span>{{ destoryed_records.qudao_name || "暂无" }}</span></div>
            <div class="business-name">商户姓名: <span>{{ info.merchant_name || "暂无" }}</span></div>
            <div class="booth-name">摊位号: <span>{{ info.boothsn || "暂无" }}</span></div>
            <div class="input-num">产品批次号: <span>{{ "暂无" }}</span></div>
        </div>
        <div class="box1">
            <div class='jiance'>
                <div class='jc-name'>商品名称: <span>{{ check_data.good_name || "暂无" }}</span></div>
                <div class='rows'>
                    <div class='jc-type'>检测项目: <span>{{ check_data.projects || "暂无" }}</span></div>
                    <div class='jc-res'>检测结果: <span>{{ check_data.result || "暂无" }}</span></div>
                </div>
                <div class='jc-time'>检测时间: <span>{{ check_data.check_time || "暂无" }}</span></div>
            </div>
        </div>
        <div class="input-ticket">
            <div class="input-top">
                票证信息
            </div>
            <div class="input-pic" v-if="zhuisuImgs.length > 0">
                <div v-for="(item, index) in zhuisuImgs" class="zs_pic" :key="index" @touchstart="preViewPic">
                    <img :src='item'>
                </div>
            </div>
            <div v-else class="empty">
                <van-empty description="暂无追溯图片！" />
            </div>
        </div>
    </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
    data() {
        return {
            info: {
                mid: "",
                keys: "",
                goodsname: "",
                market_id: "",
                boothsn: "",
                merchant_name: "",
            },
            check_data: "",
            destoryed_records: "",
            zhuisuImgs: []
            // "http://gips3.baidu.com/it/u=1022347589,1106887837&fm=3028&app=3028&f=JPEG&fmt=auto?w=960&h=1280",
            // "http://gips2.baidu.com/it/u=1674525583,3037683813&fm=3028&app=3028&f=JPEG&fmt=auto?w=1024&h=1024",
            // "http://gips3.baidu.com/it/u=1022347589,1106887837&fm=3028&app=3028&f=JPEG&fmt=auto?w=960&h=1280",
            // "http://gips2.baidu.com/it/u=1674525583,3037683813&fm=3028&app=3028&f=JPEG&fmt=auto?w=1024&h=1024"
        }
    },
    created() {
        this.info.mid = this.$route.query.mid
        this.info.keys = this.$route.query.keys
        this.info.goodsname = this.$route.query.goodsname
        this.info.market_id = this.$route.query.market_id
        this.info.boothsn = this.$route.query.boothsn
        this.info.merchant_name = this.$route.query.merchant_name
        this.getZhuisuInfo()
    },
    mounted() { },
    methods: {
        // 解析URL
        getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            //匹配所有符合条件的，并取最后一个
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", 'g');
            var results = url.match(regex);
            var tempResults = results != null && results[results.length - 1] != undefined ? results[results.length - 1] : '';
            var finalResults = regex.exec(tempResults);
            if (!finalResults) return "";
            if (!finalResults[2]) return '';
            return decodeURIComponent(finalResults[2].replace(/\+/g, " "));
        },
        // 封装请求列表数据的方法
        async getZhuisuInfo() {
            // 调用 axios 的 get 方法，请求列表数据
            var data = {
                goodsname: this.info.goodsname,
                mid: this.info.mid,
                market_id: this.info.market_id,
                boothsn: this.info.boothsn,
            }
            const { data: res } = await this.$https.post('/market/ticket/get-zs-info', data)
            // 只要请求回来的数据，在页面渲染期间要用到，则必须转存到 data 中
            if (res.resultCode === 1) {
                this.check_data = res.resultInfo.check_data
                this.destoryed_records = res.resultInfo.destoryed_records
                this.zhuisuImgs = res.resultInfo.destoryed_records.imgs
            }
        },
        timestampToTime(timestamp) {
            var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var D = date.getDate();
            D = D < 10 ? '0' + D : D;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var m = date.getMinutes();
            m = m < 10 ? '0' + m : m;
            var s = date.getSeconds();
            s = s < 10 ? '0' + s : s;
            return Y + M + D + ' ' + h + ':' + m + ':' + s;
        },
        toIndex() {
            this.$router.push({
                path: "/index",
                query: {
                    keys: this.info.keys,
                },
            });
        },
        preViewPic() {
            ImagePreview({
                images: this.zhuisuImgs,
            })
        }
    },
}
</script>

<style lang="less" scoped>
.page {
    width: 100vw;
    min-height: 100vh;
    height: fit-content;
    background-color: #f6f6f6 !important;
    padding-bottom: .5333rem;
}

.top {
    position: relative;
    width: 100%;
    height: 1.28rem;
    text-align: center;
    background-color: #fff !important;
}

.top h3 {
    font-size: .64rem;
    line-height: 1.28rem;
    font-weight: 700;
    color: #313f4c;
    margin-top: 0;
}

.out {
    position: absolute;
    top: .2667rem;
    left: .2667rem;
    width: .8rem;
    height: .8rem;
    background: url(../assets/out.png) no-repeat center;
}

.market-message {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 94%;
    height: 3rem;
    margin-left: 3%;
    background-color: #fff;
    margin-top: .32rem;
    box-sizing: border-box;
    border-radius: .1067rem;
    padding: .2667rem 0;
}

.market-message>div {
    flex: 1;
    line-height: .6667rem;
    font-size: .3733rem;
    padding: 0 .2133rem;
    color: #3a3a3a;
}

.market-message span {
    float: right;
    font-size: .3733rem;
}

.jiance {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 94%;
    height: 2.4rem;
    margin-left: 3%;
    background-color: #fff;
    margin-top: .32rem;
    box-sizing: border-box;
    border-radius: .1067rem;
    padding: .2667rem 0;
}

.jiance>div {
    flex: 1;
    line-height: .6213rem;
    font-size: .3733rem;
    padding: 0 .2133rem;
    color: #3a3a3a;
}

.rows>div {
    float: left;
    width: 50%;
    overflow: hidden;
}

.rows>div:nth-child(2) {
    float: right;
}

.jc-res {
    text-align: right;
}

.jiance span {
    font-size: .3733rem;
}

.input-ticket {
    margin-top: .48rem;
}

.input-top {
    text-align: center;
    padding: 0 .2667rem;
    width: 3.3rem;
    height: 1rem;
    line-height: 1rem;
    background-color: #36d078;
    color: #fff;
    border-radius: .08rem;
    margin-left: 3%;
    font-size: .5333rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.input-pic {
    width: 94%;
    height: 10rem;
    margin-left: 3%;
    background-color: #fff;
    margin-top: .32rem;
    box-sizing: border-box;
    border-radius: .1067rem;
    padding-bottom: .2667rem;
    padding-left: 3%;
    // display: flex;
    // flex-wrap: wrap;
    // align-items: flex-start;
}

.empty {
    width: 94%;
    height: 10rem;
    margin-left: 3%;
    background-color: #fff;
    margin-top: .32rem;
}

.input-pic>div {
    float: left;
    width: 30.2% !important;
    height: 2.8rem !important;
    padding: .35rem 0rem;
    box-sizing: border-box;
    margin-right: .2667rem;
}

.input-pic>div img {
    width: 100% !important;
    height: 2.8rem !important;
    box-sizing: border-box;
}

.input-pic>div:nth-child(3n) {
    margin-right: 0;
}

.input-pic>div:nth-child(n+4) {
    margin-top: .2667rem;
}
</style>